import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext, getUserToken } from "../../contexts/AuthContext";
import Header from "../Header";
import config from "../../config";
import { EventContext } from "../../pages/EventWrapper";
import EventMap from "./EventMap";
import Error from "../Error";
import EventDetails from "./EventDetails";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { NotificationContext } from "../../contexts/NotificationContext";
import { ModalContext } from "../../contexts/ModalContext";
import { generateId } from "../../util/Random";
import { wrapFetch } from "../../util/Hmac";

function EventDetail() {
    const navigate = useNavigate();
    const { addNotification } = useContext(NotificationContext);
    const { openModal } = useContext(ModalContext);
    const { id } = useParams();
    const [event, setEvent] = useContext(EventContext);
    const authValue = useContext(AuthContext);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    async function deleteEvent() {
        const token = await getUserToken();
        const res = await fetch(`${config.geoid_url_v3}/v3/cms/event/${event.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (res.status === 200) {
            navigate('/events');
            addNotification('Event was removed successfully', 'SUCCESS');
        } else {
            const result = await res.json();
            addNotification(result.message, 'ERROR');
        }
    }

    useEffect(() => {
        async function getData() {
            try {
                const result = await wrapFetch(`${config.geoid_url_v3}/v3/cms/event/${id}?cb=${generateId(8)}`);

                setEvent(result);
                document.title = `GeoCMS\u00ae | ${result.name}`;
            } catch (error) {
                setError(error);
            } finally {
                setIsLoaded(true);
            }
        }

        if (authValue && authValue.user) {
            getData();
        }
    }, [id, setEvent, authValue]);

    if (error) {
        return (
            <div className="Event">
                <Header heading="Event" />

                <Error error={error} />
            </div>
        )
    } else if (!isLoaded) {
        return (
            <div className="Event">
                <Header heading="Event" loading={true} />

                <div className="flex flex-col max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <div className="bg-gray-200 w-full animate-pulse h-64 rounded-lg mb-4"></div>
                </div>
            </div>
        )
    } else if (event) {
        return (
            <div className="Event">
                <Header heading={event.name} >
                    <button
                        onClick={() => openModal(`You are about to remove ${event.name}`, 'Are you sure you want to remove this event? You can\'t undo this action later.', 'Cancel', 'Remove', () => deleteEvent())}
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-300">
                        Remove
                        <XMarkIcon className="ml-1 h-5 w-5" />
                    </button>
                </Header>

                <div className="flex flex-col max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <EventDetails />

                    <EventMap />
                </div>
            </div>
        )
    }
}

export default EventDetail;